import { render, staticRenderFns } from "./TasksLeftSidebar.vue?vue&type=template&id=3529bd54&"
import script from "./TasksLeftSidebar.vue?vue&type=script&lang=js&"
export * from "./TasksLeftSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TasksLeftSidebar.vue?vue&type=style&index=0&id=3529bd54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports